const initialState = {
    percentage: 0,
    cancelToken: null
}

function setAuthReducer(state = initialState, action) {
    switch (action.type) {
        case "SET_CANCELTOKEN":
            return { ...state, cancelToken: action.cancelToken }
        case "SET_PERCENTAGE":
            return { ...state, percentage: action.percentage }
        default:
            return state
    }
}

export default setAuthReducer